import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import { reducer } from './reducer';
export function factoryStore(initialState) {
    // https://github.com/zalmoxisus/redux-devtools-extension#installation
    var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    var logger = createLogger({
        collapsed: true,
        diff: true,
        level: { prevState: false, nextState: false },
        colors: {
            title: false,
            prevState: false,
            action: false,
            nextState: false,
            error: false,
        },
    });
    var thunkMiddleware = thunk;
    var promiseMiddleware = promise;
    var loggerMiddleware = logger;
    var middlewares = [thunkMiddleware, promiseMiddleware];
    if (process.env.NODE_ENV === 'development')
        middlewares.push(loggerMiddleware);
    return createStore(reducer, initialState, composeEnhancers(applyMiddleware.apply(void 0, middlewares)));
}
